export default __webpack_public_path__ + "static/media/logo-white.d7931e95.svg";